import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import './style.css'
const faqs = [
  {
    question: "What is PlayGG?",
    answer:
      "PlayGG is the ultimate gaming hub. Book top-tier gaming cafes online, compete in thrilling tournaments for real prizes, gear up affordably from our marketplace, and connect with a vibrant gaming community. It's your gateway to a complete gaming universe.",
  },
  {
    question: "When is the PlayGG app launching?",
    answer: "The PlayGG app is launching soon! Stay tuned for updates on our official launch date.",
  },
  {
    question: "What features will the PlayGG app have?",
    answer:
      "The app will include:\n- Gaming tournaments\n- Gaming cafe bookings\n- Mini-games\n- A community feature\n- Marketplace",
  },
  {
    question: "How can I download the PlayGG app?",
    answer: "Once launched, the app will be available for download on both the Google Play Store and Apple App Store.",
  },
  {
    question: "Is the PlayGG platform currently accessible?",
    answer: "The full features of PlayGG will be available exclusively in the app once it is launched.",
  },
  {
    question: "Will the app be free to use?",
    answer: "The app will be free to download, but certain services, like tournament participation and cafe bookings, may have associated charges.",
  },
  {
    question: "Can I sign up before the app launches?",
    answer: "Currently, registrations will open once the app is live. Stay connected with us for announcements.",
  },
  {
    question: "In which cities will the app's services be available?",
    answer: "PlayGG will initially be available in select cities in India. Check back soon for the list of supported locations.",
  },
  {
    question: "How can I stay updated about the app launch?",
    answer: "Follow us on our social media channels or visit our website for the latest updates about the PlayGG app launch.",
  },
  {
    question: "Will there be customer support in the app?",
    answer: "Yes, the app will include a dedicated support section to address your queries and assist with any issues.",
  },
  {
    question: "Can I book gaming cafes or register for tournaments through the website?",
    answer: "No, all features and services will be available exclusively in the app once it launches.",
  },
  {
    question: "How do I report bugs or suggest features for the app?",
    answer: "After launch, you can use the app’s support section to report issues or share your feedback.",
  },
  {
    question: "Is the PlayGG app safe and secure to use?",
    answer: "Yes, PlayGG prioritizes user security and privacy. All data and transactions will be protected using industry-standard measures.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-black text-white p-6 max-w-2xl mx-auto">
      <h2 className="faqheader text-xl font-bold text-center mb-4">Frequently Asked Questions - PlayGG</h2>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-gray-700 pb-2">
            <button
              className="w-full text-left flex justify-between items-center py-2 focus:outline-none"
              onClick={() => toggleFAQ(index)}
            >
              <span className="text-lg font-small">{faq.question}</span>
              {openIndex === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>
            {openIndex === index && <p className="mt-2 text-gray-400">{faq.answer}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
